export default __webpack_public_path__ + "static/media/skirmishers_krys.bdbb840b.jpg";